import { useTranslation } from 'react-i18next';
import { PrimeOrNonPrime } from '@steelbuy/ts-shared';
import { IconIdentifier, Tag, TagVariant } from '@steelbuy/ui-primitive';

interface ListingTeaserCartQualityProps {
    primeStatus: PrimeOrNonPrime;
}

export const ListingTeaserCartQuality = ({ primeStatus }: ListingTeaserCartQualityProps) => {
    const { t } = useTranslation('uiDomain');
    if (!primeStatus) return null;

    const { prime, nonPrime } = primeStatus;

    return (
        <div className="listing-teaser__container__prime-status">
            {prime && (
                <Tag label={t('listingTeaserContainer.prime')} icon={IconIdentifier.PRIME} variant={TagVariant.PRIME} />
            )}
            {nonPrime && <Tag label={t('listingTeaserContainer.nonPrime')} variant={TagVariant.NON_PRIME} />}
        </div>
    );
};
